import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retry && !url.startsWith("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fieldErrorsFrom422 = (detail) => {
  const out = {};
  if (!Array.isArray(detail)) return out;
  detail.forEach((d) => {
    const field = d?.loc?.[d.loc.length - 1];
    if (field) out[field] = (d.msg || "Invalid value").replace(/^Value error, /, "");
  });
  return out;
};

export const isValidUrl = (v) => {
  try {
    const u = new URL(v);
    return ["http:", "https:"].includes(u.protocol) && u.hostname.includes(".");
  } catch {
    return false;
  }
};

export const formatMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

// Backend-served assets come back as "/api/..." paths; resolve them against the backend URL.
export const assetUrl = (src) => (src && src.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src || "");
